export function TraitBoolValue(
    defaultValue: string | boolean
): boolean | null | undefined {
    String(defaultValue).toLowerCase()
    switch (true) {
        case defaultValue === 'true':
            return true
        case defaultValue === 'false':
            return false
        case defaultValue === 'null':
            return null
        default:
            return undefined
    }
}
